import React from 'react';
import { css } from '@emotion/react';

const containerStyles = css`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  align-items: center;
  justify-content: flex-start;
  padding: 80px 24px;
  background-color: #fcfbf9;
  gap: 0;
`;

const logoStyles = css`
  width: 160px;
  height: auto;
  margin-bottom: 48px;
`;

const headingStyles = css`
  font-family: 'FlodeskSans', sans-serif;
  font-size: 48px;
  font-weight: 500;
  color: #241a17;
  margin: 0 0 24px;
  text-align: center;
  line-height: 1.05;
  letter-spacing: -0.02em;
  white-space: nowrap;

  @media (max-width: 640px) {
    font-size: 28px;
  }
`;

const subheadingStyles = css`
  font-family: 'FlodeskSans', sans-serif;
  font-size: 18px;
  font-weight: 400;
  color: #7a6860;
  margin: 0;
  text-align: center;
  line-height: 1.6;
`;

export default function Home() {
  return (
    <div css={containerStyles}>
      <img css={logoStyles} src="/flodesk.png" alt="Flodesk" />
      <h1 css={headingStyles}>Your blank canvas is ready</h1>
      <p css={subheadingStyles}>
        This is your starting point. Describe what you want to build and it happens.
      </p>
    </div>
  );
}
